angular.module('atlasDemo', [ 
        'ngSanitize', 
        'adaptv.adaptStrap', 
        'ui.bootstrap', 
        'ui.layout', 
        'rzModule', 
        'firebase', 
        'ngTagsInput' ]);

